import React from 'react';
import classNames from 'classnames';
import { Button, ButtonModes } from '@hallmark/web.core.buttons.button';
import { Icon } from '@hallmark/web.core.display.icon';
import { Typography, TypographyVariants } from '@hallmark/web.core.typography.typography';
import { TabItemProps, TabsBrandColors } from '../tabs-types';
import styles from '../tabs.module.scss';

export const TabItem = ({
  buttonRef,
  label,
  selected,
  id,
  index,
  onClick,
  onKeyDown,
  onKeyUp,
  marginLarge,
  icon,
}: TabItemProps): React.ReactElement => {
  const listClasses = classNames(
    styles['tab-item'],
    { [styles['tab-item-selected']]: selected },
    { [styles['tab-item--large-content']]: marginLarge },
  );

  const buttonClasses = classNames(styles['tab-item-btn'], selected && styles['tab-item-btn-selected']);

  return (
    <div
      className={listClasses}
      role="tab"
      tabIndex={0}
      aria-selected={selected}
      data-index={`${index}`}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      data-testid={`tab-item-${index}`}
    >
      <Button
        id={id}
        mode={ButtonModes.Icon}
        ariaLabel={`${icon} icon button ${label ? label : ''}`}
        click={onClick}
        addClass={buttonClasses}
        key={index}
        ariaControls="tab-content-panel"
        ref={buttonRef}
        tabIndex={selected ? 0 : -1}
      >
        <Icon testId={`icon-${icon}`} name={icon} addClass={styles.icon} />
        <Typography color={TabsBrandColors.CharcoalGrey} variant={TypographyVariants.TextLink}>
          {label}
        </Typography>
      </Button>
    </div>
  );
};

TabItem.defaultProps = {
  marginLarge: false,
};
